export default __webpack_public_path__ + "static/media/hr.95aa4741.svg";